export enum ListFilterMembers {
  All = 'all',
  Following = 'following',
}
